import { useCustomQuery } from "../custom-query";
import { useCustomMutation } from "../custom-mutation";
import { get, post, put, del } from "../request-helpers";
import {
  GetServiceDiscounts,
  PostServiceDiscount,
  PutServiceDiscount,
  DeleteServiceDiscount,
  GetServiceDiscount,
} from "@/server-types";

export const useGetServiceDiscounts = (
  body: GetServiceDiscounts["body"],
  enabled?: boolean,
) => {
  return useCustomQuery({
    queryKey: ["useGetServiceDiscounts", body],
    queryFn: () => post<GetServiceDiscounts>("/service-discount/search", body),
    enabled: enabled ?? true,
  });
};

export const usePostServiceDiscount = () => {
  return useCustomMutation({
    mutationFn: (props: { body: PostServiceDiscount["body"] }) =>
      post<PostServiceDiscount>("/service-discount", props.body),
  });
};

export const useGetServiceDiscount = (
  discountId?: number,
  enabled?: boolean,
) => {
  return useCustomQuery({
    queryKey: ["useGetServiceDiscount", discountId],
    queryFn: () => get<GetServiceDiscount>(`/service-discount/${discountId!}`),
    enabled: (enabled ?? true) && discountId != null && discountId !== -1,
  });
};

export const usePutServiceDiscount = () => {
  return useCustomMutation({
    mutationFn: (props: {
      discountId: number;
      body: PutServiceDiscount["body"];
    }) =>
      put<PutServiceDiscount>(
        `/service-discount/${props.discountId}`,
        props.body,
      ),
  });
};

export const useDeleteServiceDiscount = () => {
  return useCustomMutation({
    mutationFn: (discountId: number) =>
      del<DeleteServiceDiscount>(`/service-discount/${discountId}`),
  });
};
